<template>
    <div class="light-color-bg position-relative">
        <QuestionTitle number="01" :question="question" @activateModal="modalActive=true" :modalActivator="true" :modalActive="modalActive"></QuestionTitle>
        <div class="container-70">
            <DoubleButtonChoice :button1="button1" :button2="button2" v-model="result" class="mt-100px" @update:modelValue="saveAndContinue('organisationFlotteChoice', JSON.stringify(result.label), result.link)" ></DoubleButtonChoice>
            <AvancementLine percent="37.5%" class="mt-50px"></AvancementLine>
        </div>
        <ModalInfo @closeModal="modalActive=false" v-if="modalActive">
            <h3 class="modal-title">GES émis par vos transports</h3>
            <p class="modal-text">Au Québec, c'est le secteur des transports qui émet le plus de GES et contribue le plus aux changements climatiques. Cette section permet d'estimer les GES émis par les transports effectués dans le cadre des activités de votre organisation. Elle est divisée en trois catégories, soit les déplacements effectués avec votre flotte de véhicules, ceux effectués avec les véhicules personnels de vos employés, ainsi que ceux effectués en transports en commun.</p>
        </ModalInfo>
    </div>
</template>
<script>
import QuestionTitle from '@/components/QuestionTitle.vue'
import DoubleButtonChoice from '@/components/DoubleButtonChoice.vue'
import AvancementLine from '@/components/AvancementLine.vue'
import ModalInfo from '@/components/ModalInfo.vue'
/*Mixins*/
import utils from '@/mixins/utils'
export default {
    data() {
        return {
            result:null,
            question:'Est-ce que votre organisation possède une flotte de véhicules?',
            modalActive:false,
            button1:{
                link:'./question-2',
                label:'Oui'
            },
            button2:{
                link:'./question-4',
                label:'Non'
            }
        }
    },
    components: {
        QuestionTitle,
        ModalInfo,
        AvancementLine,
        DoubleButtonChoice
    },
    mixins:[utils]
}
</script>